export default interface Lookup {
    id: number;
    name: string;
}

export const noneLookup: Lookup = {
    id: 1,
    name: '-'
}
